import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";

import { makeStyles } from "../../theme/Theme";
import { Price } from "../ui/Price";

const useStyles = makeStyles((theme) => ({
  mutualFundContainer: {
    display: "flex",
    flexDirection: "column",
    padding: theme.typography.pxToRem(16),
    borderRadius: theme.typography.pxToRem(16),
    overflow: "hidden",
    border: "1px solid transparent",
    background: theme.palette.walter.main,
    boxShadow: theme.shadows[5],
  },
  fundTitle: {
    color: theme.palette.cow.main,
    marginBottom: theme.typography.pxToRem(12),
  },
  totalValue: {
    color: theme.palette.cow.main,
  },
}));

interface ManageFundsMutualFundDisplayProps {
  mutualFund?: MutualFund.MutualFundAssetProps;
}

export function ManageFundsMutualFundDisplay({ mutualFund }: ManageFundsMutualFundDisplayProps) {
  const classes = useStyles();

  if (!mutualFund) {
    return <Typography>Информация о фонде не найдена</Typography>;
  }

  return (
    <Box className={classes.mutualFundContainer}>
      <Typography variant="button3" className={classes.fundTitle}>
        {mutualFund.title}
      </Typography>
      <Price
        variant="input2"
        className={classes.totalValue}
        price={mutualFund?.value?.total}
        currency={mutualFund.currency}
      />
    </Box>
  );
}
